import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { App as AntdApp } from 'antd';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import AppWrapper from '@/components/AppWrapper';
import ProtectedRoute from '@/components/ProtectedRoute';
import MainLayout from '@/components/Layout';
import LazyPage from '@/components/LazyPage';
import PageLoader from '@/components/PageLoader';
import KpiDetails from '@/pages/KpiDetails';
import Test from '@/pages/Test';

import {
  Login,
  ForgotPassword,
  Home,
  Settings,
  NotFound,
  DataUpload,
  ViewCharts,
  TemplateManagement,
  UserManagement,
  ActivityLog,
  RoleManagement,
  PermissionManagement,
  DataHouse
} from './pages';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});



function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AntdApp className="!font-montserrat">
        <Router>
          <AppWrapper>
            <Routes>

              <Route
                path="/login"
                element={
                  <LazyPage
                    fallback={<PageLoader message="Loading login..." />}
                    pageName="Login"
                  >
                    <Login />
                  </LazyPage>
                }
              />

              <Route path="/forgot-password" element={
                <LazyPage
                  fallback={<PageLoader message="Loading forgot password..." />}
                  pageName="ForgotPassword"
                >
                  <ForgotPassword />
                </LazyPage>
              } />

              <Route path="/test" element={
                <Test />
              } />

              <Route path="*" element={
                <LazyPage
                  fallback={<PageLoader message="Loading..." />}
                  pageName="NotFound"
                >
                  <NotFound />
                </LazyPage>
              } />

              <Route path="/" element={
                <ProtectedRoute>
                  <MainLayout />
                </ProtectedRoute>
              }>

                <Route index element={
                  <LazyPage
                    fallback={<PageLoader message="Loading home..." />}
                    pageName="Home"
                  >
                    <Home />
                  </LazyPage>
                } />

                <Route path="data-upload" element={
                  <LazyPage
                    fallback={<PageLoader message="Loading dashboard..." />}
                    pageName="DataUpload"
                  >
                    <DataUpload />
                  </LazyPage>
                } />

                <Route path="view-charts" element={
                  <LazyPage
                    fallback={<PageLoader message="Loading dashboard..." />}
                    pageName="ViewChart"
                  >
                    <ViewCharts />
                  </LazyPage>
                } />

                <Route path="kpi-details/:id" element={
                  <LazyPage
                    fallback={<PageLoader message="Loading dashboard..." />}
                    pageName="kpi-details"
                  >
                    <KpiDetails />
                  </LazyPage>
                } />

                <Route path="template-management" element={
                  <LazyPage
                    fallback={<PageLoader message="Loading template management..." />}
                    pageName="TemplateManagement"
                  >
                    <TemplateManagement />
                  </LazyPage>
                } />

                <Route path="user-management" element={
                  <LazyPage
                    fallback={<PageLoader message="Loading user management..." />}
                    pageName="UserManagement"
                  >
                    <UserManagement />
                  </LazyPage>
                } />


                <Route path="data-house" element={
                  <LazyPage
                    fallback={<PageLoader message="Loading user management..." />}
                    pageName="DataHouse"
                  >
                    <DataHouse />
                  </LazyPage>
                } />

                <Route path="activity-logs" element={
                  <LazyPage
                    fallback={<PageLoader message="Loading activity log..." />}
                    pageName="ActivityLog"
                  >
                    <ActivityLog />
                  </LazyPage>
                } />

                <Route path="settings" element={
                  <LazyPage
                    fallback={<PageLoader message="Loading settings..." />}
                    pageName="Settings"
                  >
                    <Settings />
                  </LazyPage>
                } />

                <Route path="role-management" element={
                  <LazyPage
                    fallback={<PageLoader message="Loading role management..." />}
                    pageName="RoleManagement"
                  >
                    <RoleManagement />
                  </LazyPage>
                } />

                <Route path="permission-management" element={
                  <LazyPage
                    fallback={<PageLoader message="Loading permission management..." />}
                    pageName="PermissionManagement"
                  >
                    <PermissionManagement />
                  </LazyPage>
                } />

              </Route>

            </Routes>
          </AppWrapper>
        </Router>
      </AntdApp>
    </QueryClientProvider>
  );
}

export default App;
